import React from "react";
import { transformVar } from "@quarkly/atomize";
import { createGlobalStyle } from "styled-components";

const pageStyles = {
    "404": {},
    "index": {},
    "instrukciya": {},
    "prodvizhenie-internet-magazina-v-telegram": {},
    "dlya-chego-sozdat-magazin-v-telegram": {},
    "delayem-magazin-v-telegram": {},
    "prodazha-elektronnykh-tovarov-v-telegram": {},
    "support-bot-magazin": {},
    "uvedomleniya-o-zakazakh-v-magazine-v-telegram": {},
    "onlayn-oplata-v-telegram-magazine": {},
    "poluavtomaticheskiy-priyem-oplaty": {},
    "onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh": {},
    "create-logo": {},
    "oformlenie-magazina-v-telegram": {},
    "prava-na-bot-magazin": {},
    "en": {},
    "en/instrukciya": {}
};

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
            Object.entries(styles || {}).map(
                ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
            )}
    }
`;
export const GlobalQuarklyPageStyles = ({ pageUrl }) => <PageStyles styles={pageStyles[pageUrl]} />
